import { useCallback } from "react";
import { useNavigate } from "react-router";
import { getNavigationDestinationHref } from "components/TopNavigationBar/navigationDestination.ts";
import { CabinetworksGroupApplication } from "types/declarations/enums.ts";
import { DashboardDestination } from "../Dashboard.types";

export const useDashboardNavigation = () => {
	const navigate = useNavigate();

	return useCallback(
		(destination: DashboardDestination) => {
			if (destination.application === CabinetworksGroupApplication.Salesforce) {
				globalThis.location.href = getNavigationDestinationHref({
					application: destination.application,
					path: destination.href
				});
				return;
			}
			navigate(destination.href);
		},
		[navigate]
	);
};
